export const shouldGuardSurveyEditorUnload = ({
  isDirty = false,
  isSaving = false,
} = {}) => isDirty && !isSaving;

export const preventSurveyEditorUnload = event => {
  if (!event) return false;

  event.preventDefault();
  event.returnValue = '';
  return true;
};
